import {PATH_CONTROLLO_A2D } from "../config/presdoc-fe-config";

// Il vettore esclusioni contiene i servizi esclusi dal metodo onResponseError del file network-config.js
export const esclusioniOnResponseError = [
    PATH_CONTROLLO_A2D
]


export const A2D_ERROR_CODE_ANTIVIRUS = 'TT0037';

export const A2D_STATUS_DA_ESEGUIRE =	0
export const A2D_STATUS_IN_ELABORAZIONE = 1
export const A2D_STATUS_ELABORATO = 2
export const A2D_STATUS_IN_ERRORE =	3
export const A2D_STATUS_SCARTATO =	4
export const A2D_STATUS_IN_ATTESA =	5